function SummaryFisheryMasthead({
  fisheryInfo,
  className = '',
  ...additionalProps
}) {
  // Only show components which are present, if no components are available try using address.one_line
  const addressComponents = [
    fisheryInfo?.city ?? fisheryInfo?.address?.city,
    fisheryInfo?.postcode ?? fisheryInfo?.address?.postcode,
  ].filter((c) => c);
  const address = addressComponents.length
    ? addressComponents.join(', ')
    : fisheryInfo?.one_line;

  return (
    <div
      className={'user-booking-summary__masthead ' + className}
      {...additionalProps}
      style={{
        backgroundImage: `
          linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), 
          url(${
            fisheryInfo?.image ?? fisheryInfo?.images?.primary
          })` /* Darkens image */,
        backgroundSize: 'cover',
        backgroundBlendMode: 'multiply',
        backgroundPosition: 'center',
      }}
    >
      <div className={'user-booking-summary__masthead__content pd-30'}>
        <h2 className={'gSemiBold fs-28 white mg-bottom-10'}>
          {fisheryInfo?.venue_name}
        </h2>
        <p className={'gRegular fs-15  white txt-right mg-bottom-0'}>
          {address}
        </p>
      </div>
    </div>
  );
}

export default SummaryFisheryMasthead;
